<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Buyer Criteria<span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))">Opportunity<span style="padding:8px;">|</span></li>
    <li *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Broker))">My Deals <span style="padding:8px;">|</span></li>
    <li>Buyer Criteria</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div table-fixed margin0">
          <div class="floatinghead clearfix d-flex align-items-center justify-content-end">

            <div class="rightside clearfix">
              <label class="form-label margin-bottom-0">&nbsp;</label>
              <div class="search-sec">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Principal/Company/Tenant/State/Asking Price/Property Types">
                <i class="fa fa-search icon" aria-hidden="true"></i>
              </div>
            </div>

            <div class="rightside clearfix" style="margin: 5px 0px 0px 10px;">
              <div class="select-dropdown multiselectdesign mb-0 multi-check-dropdown pull-right">
                <mat-form-field>
                  <mat-select placeholder="Select Columns"
                              [(ngModel)]="selectedColumns"
                              multiple>
                    <mat-select-trigger>
                      <span>Select Columns</span>
                    </mat-select-trigger>
                    @for (column of tableColumns; track column) {
                    <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
                    }
                    @if (tableColumns.length === 0) {
                    <mat-option class="matoptionnodata" disabled>
                      Nothing found...
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th class="min-width-td sticky-left z-100">Principal</th>
                  <th [hidden]="hideColumn(1)">Company</th>
                  <th [hidden]="hideColumn(2)">Tenants</th>
                  <th [hidden]="hideColumn(3)">States</th>
                  <th [hidden]="hideColumn(4)">Asking Price</th>
                  <th [hidden]="hideColumn(5)">Cap Rate</th>
                  <th [hidden]="hideColumn(6)">Remaining Lease Term</th>
                  <th [hidden]="hideColumn(7)">Property Types</th>
                  <th [hidden]="hideColumn(8)">Lease Structure</th>
                  <th [hidden]="hideColumn(9)">Regions</th>
                  <th [hidden]="hideColumn(10)">Sub-Category</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of flaggedList;let i = index ">
                  <td class="sticky-left">
                    <p>
                      <a [attr.href]="canViewCriteria ? 'javascript:void(0);' : null"
                         [routerLink]="canViewCriteria ? '/registered-user-details/': null" [class.disabled-redirection-link]="!canViewCriteria" [queryParams]="{principal:row.Guid,prevroute:currentpage,link:currenturl}">{{ row.Name }}</a>
                    </p>
                    <p *ngIf="row.PhoneNumber">{{ row.PhoneNumber | phone }}</p>
                    <p *ngIf="row.Email">{{row.Email}}</p>
                  </td>
                  <td [hidden]="hideColumn(1)"><p>{{ row.CompanyName }}</p></td>
                  <td [hidden]="hideColumn(2)" class="tool-top-box"><p tooltip="{{row.SelectedTenants}}">{{GetPropertyTypeWithCount(row.SelectedTenants)}}</p></td>
                  <td [hidden]="hideColumn(3)" class="tool-top-box"><p tooltip="{{ row.States }}">{{GetPropertyTypeWithCount(row.States)}}</p></td>
                  <td [hidden]="hideColumn(4)"><p>{{ row.Askingpricemin ? row.Askingpricemax ? (' $ '+ (row.Askingpricemin | number:0)+' - $ ' +(row.Askingpricemax| number:0)):('$ ' +(row.Askingpricemin| number:0)) :row.Askingpricemax ? ('$ '+(row.Askingpricemax| number:0)): '-' }}</p></td>
                  <td [hidden]="hideColumn(5)"><p>{{ row.CapRateMin ? row.CapRateMax ? (row.CapRateMin+' % - ' +row.CapRateMax +' %'):(row.CapRateMin+' %') :row.CapRateMax ? (row.CapRateMax+' % - '): '-' }}</p></td>
                  <td [hidden]="hideColumn(6)"><p>{{ row.RemainingLeaseTerm ? row.RemainingLeaseTerm : '-' }}</p></td>
                  <td [hidden]="hideColumn(7)" class="tool-top-box pos-relative"><p placement="left" tooltip="{{row.PropertyTypes}}">{{GetPropertyTypeWithCount(row.PropertyTypes)}}</p></td>
                  <td [hidden]="hideColumn(8)" class="tool-top-box pos-relative"><p placement="left" tooltip="{{row.LeaseTerm}}">{{GetPropertyTypeWithCount(row.LeaseTerm)}}</p></td>
                  <td [hidden]="hideColumn(9)" class="tool-top-box pos-relative"><p placement="left" tooltip="{{row.GeographyType}}">{{GetPropertyTypeWithCount(row.GeographyType)}}</p></td>
                  <td [hidden]="hideColumn(10)" class="tool-top-box pos-relative"><p placement="left" tooltip="{{row.Subcategories}}">{{GetPropertyTypeWithCount(row.Subcategories)}}</p></td>

                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="flaggedList?.length==0&&!IsLoading">
                  <td colspan="15" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




